import { IScriptLoader } from "./IScriptLoader";
import sys from '@truckdown/jsclient';
import * as apis from "@truckdown/jsclient/apis";

export class ScriptLoader implements IScriptLoader {
    constructor() {

    }

    loadScript(id: string, url: string, attributes?: { [name: string]: string }): Promise<void> {
        return new Promise<void>(function (resolve, reject) {
            try {
                let script = document.getElementById(id);
                if (script) {
                    resolve();
                } else {
                    script = document.createElement('script');

                    if (attributes) {
                        Object.assign(script, attributes);
                    }

                    script.id = id;
                    script.setAttribute('src', url);
                    script.onload = (resolve as any) as (this: GlobalEventHandlers, ev: Event) => any;
                    script.onerror = (reject as any) as OnErrorEventHandler;
                    document.head.appendChild(script);
                }
            }
            catch (err) {
                reject(err);
            }
        });
    }

    async loadHereMaps() {
        let storedPlatform = sys.getSetting<H.service.Platform>('here_platform');

        if (!storedPlatform || storedPlatform == null) {
            //NOTE: scripts have to be loaded in sequence
            await this.loadScript('here-core', 'https://js.api.here.com/v3/3.1/mapsjs-core.js', { "type": "text/javascript", "charset": "utf-8" });
            await this.loadScript('here-maps', 'https://js.api.here.com/v3/3.1/mapsjs-service.js', { "type": "text/javascript", "charset": "utf-8" });
            
            let platform = new H.service.Platform({
                apikey: sys.framework.context.getSetting('hereApiKey') ?? ''
            });
            sys.setSetting('here_platform', platform);
            return platform;
        }
        return storedPlatform;
    }
}

export default (framework: apis.framework.IFramework) => {
    framework.registerTransient<IScriptLoader>('IScriptLoader', (frm) => {
        return new ScriptLoader();
    });
}
